import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {authSelector} from "../redux/selectors";
import PerformResetForm from "./PerformResetForm";
import {performReset} from "../redux/actions";

class PerformReset extends Component {
    componentDidMount() {
        document.title = "Addiction | Reset Password";
    }
    submit = (values) => {
        this.props.onSubmit(this.props.match.params.key, values)
    };
    render() {
        if (!this.props.isAuthenticated) {
            if (!this.props.auth.passwordReset) {
                return (
                    <div>
                        <h1>Reset Password</h1>
                        <div className="panel">
                            <div className="panel-adt">
                                <PerformResetForm
                                    onSubmit={this.submit}
                                    pending={this.props.pending}
                                    errors={this.props.auth.registerError}
                                />
                            </div>
                        </div>
                    </div>
                )
            } else {
                return (
                    <div>
                        <h1>Reset Password</h1>
                        <div className="panel">
                            <div className="panel-adt">
                                <h4 className="text-primary">Success!</h4>
                                <p>You can now log in with your new password <Link to="/login">here</Link>.</p>
                            </div>
                        </div>
                    </div>
                )
            }
        } else {
            return <Redirect to="/" />

        }
    }
}

const mapStateToProps = (state) => ({
    auth: authSelector(state),
    isAuthenticated: state.auth.loggedIn,
    pending: state.auth.pending
});

const mapDispatchToProps = (dispatch) => ({
    onSubmit: (key, values) => dispatch(performReset(key, values.password1)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PerformReset);


// WEBPACK FOOTER //
// ./src/Auth/PerformReset.js